export const fmtEUR = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
};

export const fmtDate = (s) => {
  if (!s) return "—";
  // s expected "YYYY-MM-DD"
  const parts = String(s).slice(0, 10).split("-");
  if (parts.length !== 3) return s;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

export const fmtDateTime = (s, time) => {
  const d = fmtDate(s);
  return time ? `${d} · ${time}` : d;
};

export const todayISO = () => {
  const d = new Date();
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60000);
  return local.toISOString().slice(0, 10);
};

export const fmtHours = (n) => {
  const v = Number(n || 0);
  return `${v.toLocaleString("it-IT", { maximumFractionDigits: 1 })} h`;
};

export const fmtTimestamp = (iso) => {
  if (!iso) return "";
  const hasTz = iso.endsWith("Z") || /[+-]\d\d:?\d\d$/.test(iso);
  const d = new Date(hasTz ? iso : iso + "Z");
  if (isNaN(d.getTime())) return iso;
  return d
    .toLocaleString("it-IT", {
      timeZone: "Europe/Rome",
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: false,
    })
    .replace(", ", " · ");
};

export const creditsLabel = (n) => `${Number(n ?? 0)} ${Number(n) === 1 ? "credito" : "crediti"}`;

export const calcAge = (dateStr) => {
  if (!dateStr) return "";
  const b = new Date(String(dateStr).slice(0, 10));
  if (isNaN(b.getTime())) return "";
  const now = new Date();
  let months = (now.getFullYear() - b.getFullYear()) * 12 + (now.getMonth() - b.getMonth());
  if (now.getDate() < b.getDate()) months -= 1;
  if (months < 0) return "";
  const y = Math.floor(months / 12);
  const m = months % 12;
  if (y === 0) return `${m} ${m === 1 ? "mese" : "mesi"}`;
  if (m === 0) return `${y} ${y === 1 ? "anno" : "anni"}`;
  return `${y} ${y === 1 ? "anno" : "anni"} e ${m} ${m === 1 ? "mese" : "mesi"}`;
};

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
